import { escapeWithBreakLineAndTranslate, formatMessage } from "../../utils/helpers/LanguageHelper";
import React from "react";

export const ViewportTooNarrowError = () => {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        position: "fixed",
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        zIndex: 1000003,
      }}
    >
      <img
        src={"/assets/genericErrorIllustration.svg"}
        alt="viewport is too narrow to display the content correctly"
        style={{
          width: "calc(100vw - 4rem)",
          maxHeight: "calc(100vh - 3rem)",
          objectFit: "contain",
        }}
      />
      <span
        style={{
          width: "100%",
          textAlign: "center",
          color: "var(--color-blue)",
        }}
      >
        {escapeWithBreakLineAndTranslate(formatMessage("cof.viewport.error.toosmall.message"))}
      </span>
    </div>
  );
};
